export const STONE_ISSUE_MAKER = "STONE_ISSUE_MAKER";
export const GET_PENDING_ISSUE_STONE_ORDERS = "GET_PENDING_ISSUE_STONE_ORDERS";
export const GET_ISSUE_STONE_DETAILS = "GET_ISSUE_STONE_DETAILS"